module.exports = __webpack_public_path__ + "img/logo_cars_02.edb6f489.png";